import React from 'react';

import {colors} from '../../colors/colors';

import {svgIconWrapper} from '../svg-icon-wrapper';

import ConnectedForms from './icon-connected-forms.svg';

function SvgComponent(props) {
    const validProps = Object.assign({}, props);
    delete validProps.styles;

    return (
        <ConnectedForms
            {...validProps}
            fill={validProps.fill || validProps.color || colors.black}
        />
    );
}
SvgComponent.iconName = 'formMapping';

export const ConnectedFormsIcon = svgIconWrapper(SvgComponent);
